export default function PHP_is_integer() {
  return (
    <div>
      <h1>PHP_is_integer</h1>
    </div>
  );
}
